var exports = {
  "kL": "NotFoundPage.module__container___VVBhT0",
  "Kk": "NotFoundPage.module__icon___VVBhT0",
  "Qs": "NotFoundPage.module__content___VVBhT0",
  "DD": "NotFoundPage.module__title___VVBhT0",
  "h_": "NotFoundPage.module__description___VVBhT0",
  "o1": "NotFoundPage.module__actions___VVBhT0",
};

module.exports = exports;
